import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import sectorsUK from "@/.sourceflow/sectors.json";
import sectorsUS from "@/.sourceflow/job_sectors.json";

export const useJobSectors = ({ locale } = {}) => {
  const collection = useSourceFlowCollection(locale == "/us/" ? sectorsUS : sectorsUK);
  return collection;
};

export default useJobSectors;
